import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { housingFundsInputList } from '../../../common/data';
import HousingItemSection from './HousingItemSection';
import ItemTitleSection from '../../../components/ItemTitleSection';
import { formatNumber, getTotal } from '../../../common/Util';

// 주택임차차입금
const Type1 = ({ onOpen }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const inputList = housingFundsInputList(t);
  const { s10_1Data } = useSelector(state => state.housingFunds);

  return (
    <div className="displayFlexColumn" style={{ gap: '8px' }}>
      <ItemTitleSection
        title={t('detail.title1')}
        addButton={true}
        handleAddButton={() => onOpen('type1', 'detail')}
      />
      <HousingItemSection
        dataList={s10_1Data}
        inputList={inputList.slice(0, 3)}
        title={t('typeItem.title1')}
        addButton={true}
        total={formatNumber(getTotal([s10_1Data], ['htm085', 'htm086']))}
      />
      {/* 거주자 추가 25.01.14 선희 */}
      <div style={{ marginTop: '8px' }}>
        <HousingItemSection
          dataList={s10_1Data}
          inputList={inputList.slice(3, 5)}
          title={t('typeItem.title2')}
          addButton={true}
          total={formatNumber(getTotal([s10_1Data], ['htm078']))}
        />
      </div>
    </div>
  );
};

export default Type1;
